import { render, staticRenderFns } from "./ClassroomGroup.vue?vue&type=template&id=ad47b752"
import script from "./ClassroomGroup.vue?vue&type=script&lang=js"
export * from "./ClassroomGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports